import axios from "axios";
export const isFirstCharacterNotDigit = (str) => {
  if (str.length === 0) {
    // 字符串为空，可以根据需求返回 true 或 false
    return true;
  }

  // 使用正则表达式检查第一个字符是否为数字
  const firstCharacter = str.charAt(0);

  return /\d/.test(firstCharacter);
}

export const screenNewArray = (a, b) => {
 
  // 遍历 b 数组
  for (let i = 0; i < b.length; i++) {
    let found = false;
    // 遍历 a 数组，检查是否存在相同的 id
    for (let j = 0; j < a.length; j++) {
      if (a[j].id === b[i].id) {
        found = true;
        break; // 找到相同的 id，不需要继续查找
      }
    }
    // 如果 id 在 a 中不存在，将元素添加到 a 数组中
    if (!found) {
      a.push(b[i]);
    }
  }
  // 返回合并后的 a 数组
  return a;
}
 
export  const requstImg=(url,headers)=>{
  return new Promise((resolve,reject)=>{
    axios.get(url,{headers}).then(res=>{
      resolve(res)
    }).catch(err=>{
      reject(err)
    })
  })
  
}
